import React from 'react';
import { useTranslation } from 'localization';
import './EdgeCaseCalloutMolecule.scss';

export type EdgeCaseSeverity = 'info' | 'warn' | 'danger' | 'success';

export interface EdgeCaseCalloutMoleculeProps {
  severity: EdgeCaseSeverity;
  title: string;
  body: string;
  className?: string;
}

const SEVERITY_ICON: Record<EdgeCaseSeverity, string> = {
  info: 'pi-info-circle',
  warn: 'pi-exclamation-triangle',
  danger: 'pi-exclamation-circle',
  success: 'pi-check-circle',
};

const EdgeCaseCalloutMolecule: React.FC<EdgeCaseCalloutMoleculeProps> = ({
  severity,
  title,
  body,
  className = '',
}) => {
  const { t } = useTranslation();
  const rootClasses = [
    'marketplace-edge-case-callout',
    `marketplace-edge-case-callout--${severity}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const severityLabel = t(
    `marketplace.approachDetail.overview.edgeCases.severity.${severity}`,
  );

  return (
    <article className={rootClasses} role="note">
      <i
        className={`marketplace-edge-case-callout__icon pi ${SEVERITY_ICON[severity]}`}
        aria-hidden="true"
      />
      <div className="marketplace-edge-case-callout__body">
        <header className="marketplace-edge-case-callout__header">
          <span className="marketplace-edge-case-callout__severity">
            {severityLabel}
          </span>
          <span className="marketplace-edge-case-callout__title">{title}</span>
        </header>
        <p className="marketplace-edge-case-callout__text">{body}</p>
      </div>
    </article>
  );
};

EdgeCaseCalloutMolecule.displayName = 'EdgeCaseCalloutMolecule';

export default EdgeCaseCalloutMolecule;
